import { useState } from 'react';
import { weddingFaqs } from '../../../mocks/vestidosNovia';
import { useSupabaseAdmin } from '../../../hooks/useSupabaseAdmin';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

export default function AdminFAQ() {
  const { data, add, update, remove, loading } = useSupabaseAdmin<FAQItem>({
    table: 'wedding_faqs',
    initialData: weddingFaqs.map((f, i) => ({ ...f, id: i + 1 })),
  });
  const [editing, setEditing] = useState<FAQItem | null>(null);
  const [isAdding, setIsAdding] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    const payload = {
      question: fd.get('question') as string,
      answer: fd.get('answer') as string,
    };
    if (editing) {
      update(editing.id, payload);
      setEditing(null);
    } else {
      add(payload);
      setIsAdding(false);
    }
  };

  return (
    <div className="space-y-6">
      {loading && (
        <div className="flex items-center gap-2 text-brand-gray-500 text-sm">
          <i className="ri-loader-4-line animate-spin" />
          Sincronizando con la nube...
        </div>
      )}

      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-serif text-brand-black text-xl">FAQ Vestidos de Novia</h3>
          <p className="font-sans text-brand-gray-500 text-sm mt-1">
            {data.length} preguntas registradas
          </p>
        </div>
        <button
          onClick={() => { setIsAdding(true); setEditing(null); }}
          className="bg-brand-black text-white font-sans text-sm px-5 py-2.5 rounded-lg hover:bg-brand-gray-600 transition-colors whitespace-nowrap"
        >
          + Nueva pregunta
        </button>
      </div>

      {(isAdding || editing) && (
        <form
          onSubmit={handleSubmit}
          className="bg-white border border-brand-gray-200 rounded-2xl p-6 space-y-4"
        >
          <div className="flex items-center justify-between">
            <h4 className="font-serif text-brand-black text-lg">
              {editing ? 'Editar Pregunta' : 'Nueva Pregunta'}
            </h4>
            <button
              type="button"
              onClick={() => { setEditing(null); setIsAdding(false); }}
              className="w-8 h-8 flex items-center justify-center text-brand-gray-400 hover:text-brand-black"
            >
              <i className="ri-close-line text-xl" />
            </button>
          </div>
          <div>
            <label className="font-sans text-brand-gray-600 text-xs uppercase tracking-wider font-medium">Pregunta *</label>
            <input
              name="question"
              defaultValue={editing?.question}
              required
              className="mt-1 w-full border border-brand-gray-200 rounded-lg px-3 py-2 font-sans text-sm focus:outline-none focus:border-brand-black"
            />
          </div>
          <div>
            <label className="font-sans text-brand-gray-600 text-xs uppercase tracking-wider font-medium">Respuesta *</label>
            <textarea
              name="answer"
              defaultValue={editing?.answer}
              rows={4}
              required
              className="mt-1 w-full border border-brand-gray-200 rounded-lg px-3 py-2 font-sans text-sm focus:outline-none focus:border-brand-black resize-none"
            />
          </div>
          <div className="flex items-center gap-3 pt-2">
            <button type="submit" className="bg-brand-black text-white font-sans text-sm px-6 py-2.5 rounded-lg hover:bg-brand-gray-600 transition-colors whitespace-nowrap">
              Guardar
            </button>
            <button
              type="button"
              onClick={() => { setEditing(null); setIsAdding(false); }}
              className="border border-brand-gray-200 text-brand-black font-sans text-sm px-6 py-2.5 rounded-lg hover:border-brand-black transition-colors whitespace-nowrap"
            >
              Cancelar
            </button>
          </div>
        </form>
      )}

      <div className="space-y-3">
        {data.map((faq) => (
          <div key={faq.id} className="bg-white border border-brand-gray-200 rounded-2xl p-5">
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <h4 className="font-serif text-brand-black text-sm font-medium">
                  {faq.question}
                </h4>
                <p className="font-sans text-brand-gray-500 text-sm mt-2 leading-relaxed line-clamp-3">
                  {faq.answer}
                </p>
              </div>
              <div className="flex items-center gap-1 flex-shrink-0">
                <button
                  onClick={() => { setEditing(faq); setIsAdding(false); }}
                  className="w-7 h-7 rounded-md bg-brand-gray-100 flex items-center justify-center text-brand-gray-600 hover:bg-brand-black hover:text-white transition-colors"
                >
                  <i className="ri-pencil-line text-xs" />
                </button>
                <button
                  onClick={() => { if (confirm('¿Eliminar esta pregunta?')) remove(faq.id); }}
                  className="w-7 h-7 rounded-md bg-brand-gray-100 flex items-center justify-center text-brand-gray-600 hover:bg-red-600 hover:text-white transition-colors"
                >
                  <i className="ri-delete-bin-line text-xs" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}